import React from "react";

// Geometric line-art wolf head crest
export const WolfMark = ({ className = "", strokeWidth = 3 }) => (
  <svg
    viewBox="0 0 120 120"
    fill="none"
    className={className}
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinejoin="round"
    strokeLinecap="round"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M22 16 L40 30 L60 40 L80 30 L98 16 L86 48 L96 68 L74 80 L60 106 L46 80 L24 68 L34 48 Z" />
    <path d="M42 52 L56 60 L45 63" />
    <path d="M78 52 L64 60 L75 63" />
    <path d="M54 74 L60 84 L66 74" />
  </svg>
);

// Diagonal claw slashes for hero background
export const ClawMarks = ({ className = "" }) => (
  <svg
    viewBox="0 0 200 400"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M20 10 C60 120 70 260 30 390" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
    <path d="M80 0 C120 120 130 260 90 400" stroke="currentColor" strokeWidth="8" strokeLinecap="round" />
    <path d="M150 10 C190 120 200 260 160 390" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
  </svg>
);

export default WolfMark;
